export { default } from './WritingModeWrapper'
